var PrimaryBackgroundStyle = {
  warning: 'warning.main',
  critical: 'critical.main',
  success: 'success.main',
  neutral: 'neutral.black',
  brand: 'brand.main',
  informative: 'info.main'
};
var SecondaryBackgroundStyle = {
  warning: 'warning.lighter',
  critical: 'critical.lightest',
  success: 'success.lightest',
  neutral: 'neutral.lighter',
  brand: 'brand.lightest',
  informative: 'info.lightest'
};
var SecondaryColorStyle = {
  warning: 'neutral.black',
  critical: 'critical.dark',
  success: 'success.dark',
  neutral: 'neutral.black',
  brand: 'brand.dark',
  informative: 'info.dark'
};
export var getBackgroundColor = (status, type) => {
  if (type === 'status') return 'neutral.white';
  if (type === 'primary') return PrimaryBackgroundStyle[status];
  return SecondaryBackgroundStyle[status];
};
export var getColor = (status, type) => {
  if (type === 'status' || status === 'warning') return 'neutral.black';
  if (type === 'secondary') return SecondaryColorStyle[status];
  return 'neutral.white';
};
//# sourceMappingURL=_BaseBadge.theme.utils.js.map